import React, { Component } from 'react'
import { connect } from 'react-redux'
// import EventEmitter from '../../utils/events'
// import moment from 'moment'

// Utils
import { translation, enumtranslate } from '../../utils/helpers'
// import { hasAccess, hasSubscriptionPermission } from '../../utils/auth'
import { isTouchDevice } from '../../utils/detect'
import { formatCurrency } from '../../utils/currency'
import { makeOrderPageTitleObject } from '../../utils/order'
import { setPageTitle } from '../../actions/common'
import { renderFullDate } from '../../utils/time'
import { EvaluationHistoryIcons, ElementIcons, OrderAssessmentIcons } from '../../shared/elements/icons'

// import components
import Header from '../../shared/components/Header'
import Column from './Column'
import Section from './Section'
import SelectableLine from './SelectableLine'
import ExtentLine from './ExtentLine'
// import GreenCheck from '../../shared/components/GreenCheck'
import HelpText from '../../shared/components/HelpText'
import Gallery from '../../shared/components/Gallery'
import Invoice from '../../shared/components/Invoice'
import UserInfo from '../../shared/components/UserInfo'

// Elements
import Inline from '../../shared/elements/inline'
import LabelWrapper from '../../shared/elements/labelWrapper'
import Icon from '../../shared/elements/icon'
import Check from '../../shared/elements/check'
import Divider from '../../shared/elements/divider'
import Grid from '../../shared/elements/grid'
import CloseButton from '../../shared/elements/closeButton'

// Constants
import {
  // API_URL,
  FILE_STORAGE
  // FILE_STORAGE_API
} from '../../constants'

// Actions
import { getEvaluationHistory, updateEvaluationHistory } from '../../actions/evaluationhistory'
import { getOrder } from '../../actions/orders'
import { triggerPopup, triggerPopupActionBG } from '../../actions/backdrop'

import './evaluationhistory.scss'
import { hasSubscriptionPermission } from '../../utils/auth'

class EvaluationHistory extends Component {
  constructor (props) {
    super(props)

    this.md = new window.MobileDetect(window.navigator.userAgent)
    this.loadHistory = this.loadHistory.bind(this)
    this.loadOrder = this.loadOrder.bind(this)
    this.updateHistory = this.updateHistory.bind(this)
    this.renderColumns = this.renderColumns.bind(this)
    this.renderInvoiceExtra = this.renderInvoiceExtra.bind(this)
    this.renderAddonSaleColumn = this.renderAddonEntry.bind(this)
    this.renderEvaluationEntry = this.renderEvaluationEntry.bind(this)
    this.renderCreationInfoSection = this.renderCreationInfoSection.bind(this)
    this.renderItemSection = this.renderItemSection.bind(this)
    this.renderAddonSection = this.renderAddonSection.bind(this)
    this.prepareForRender = this.prepareForRender.bind(this)
    this.getOrCreatePart = this.getOrCreatePart.bind(this)
    this.getEvaluationTitle = this.getEvaluationTitle.bind(this)
    this.getEvaluationIcon = this.getEvaluationIcon.bind(this)
    this.getTaskSideName = this.getTaskSideName.bind(this)
    this.SortMe = this.SortMe.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.renderReportCalc = this.renderReportCalc.bind(this)
    this.renderReportTotals = this.renderReportTotals.bind(this)
    this.renderExternalItems = this.renderExternalItems.bind(this)
    this.renderExternalSubCustomItems = this.renderExternalSubCustomItems.bind(this)
    this.renderExternalSubItems = this.renderExternalSubItems.bind(this)
    this.renderFileContainer = this.renderFileContainer.bind(this)
    this.scroller = null

    this.state = {
      sorting: 0,
      history: null,
      swap: false
    }
  }

  componentDidMount () {
    this.loadHistory()
    this.loadOrder()
  }

  componentWillUnmount () {
    if (this.scroller !== null) {
      this.scroller.destroy()
    }
  }

  loadOrder () {
    let orderId = this.props.params.orderId
    this.props.getOrder(orderId).then((res) => {
      this.props.setPageTitle(makeOrderPageTitleObject(res.data))
    })
  }

  loadHistory () {
    this.props.triggerPopupActionBG(true)
    let orderId = this.props.params.orderId

    if (orderId !== ':orderId') {
      // Get from api
      this.props.getEvaluationHistory(orderId).then((res) => {
        this.setState({
          history: res.data
        })
        this.props.triggerPopupActionBG(false)
        /* this.initHammer() */
      }, (e) => {
        console.log('Error: ', e)
        this.props.triggerPopupActionBG(false)
        // this.props.router.goBack()
      })
    }
  }

  updateHistory (changes) {
    // Post to api
    this.props.updateEvaluationHistory(changes).then((res) => {
      let history = this.state.history

      // Order data
      if (res.data.OrderTypeSelected !== null) history.OrderTypeSelected = res.data.OrderTypeSelected
      if (res.data.PickupDateSelected !== null) history.PickupDateSelected = res.data.PickupDateSelected
      if (res.data.DeliveredDateSelected !== null) history.DeliveredDateSelected = res.data.DeliveredDateSelected
      if (res.data.LtwIdCodeSelected !== null) history.LtwIdCodeSelected = res.data.LtwIdCodeSelected
      if (res.data.ChassisNumberSelected !== null) history.ChassisNumberSelected = res.data.ChassisNumberSelected

      // Notes
      if (history.Notes !== null && res.data.Notes !== null) {
        for (let i = 0; i < res.data.Notes.length; i++) {
          let noteIndex = history.Notes.findIndex((item) => { return item.NoteId === res.data.Notes[i].NoteId })
          if (noteIndex >= 0) {
            history.Notes[noteIndex] = res.data.Notes[i]
          }
        }
      }

      if (history.History !== null && res.data.History !== null) {
        for (let i = 0; i < res.data.History.length; i++) {
          let historyIndex = history.History.findIndex((entry) => {
            return (
              entry.OrderPriceId === res.data.History[i].OrderPriceId && entry.ReportId === res.data.History[i].ReportId && entry.State === res.data.History[i].State
            )
          })
          if (historyIndex >= 0) {
            history.History[historyIndex] = res.data.History[i]
          }
        }
      }

      this.setState({
        history: history
      })
    })
  }

  debindAll () {
    if (this.scroller !== null) { this.scroller.destroy() }
    let hammerTime = new window.Hammer(window.board, {
      inputClass: window.Hammer.TouchInput
    })
    hammerTime.off('swipeleft')
    hammerTime.off('swiperight')
  }

  allowHammer () {
    let allowSize = window.innerWidth < 1360
    let androidTablet = (this.md.os() === 'AndroidOS' && this.md.tablet())
    if (isTouchDevice() && !androidTablet && allowSize) {
      return true
    }
    return false
  }

  panHandler (event) {
    if (event.type === 'panend' || event.type === 'pancancel') {
      // iOS bug fix
      this.lock = false
      this.delta = 0
      this.lastDirection = null
      this.lastDelta = 0
      this.deltaX = 0
    } else if ((event.type === 'swipe' || event.type === 'panmove') && event.direction & window.Hammer.DIRECTION_VERTICAL) {
      this.lock = true
    } else if (event.type === 'swipe' && event.direction & window.Hammer.DIRECTION_HORIZONTAL) {
      // iOS bug fix
      this.lock = true
    } else if (event.type === 'panmove' && event.direction & window.Hammer.DIRECTION_HORIZONTAL) {
      if (this.lastDirection === null) {
        this.lastDirection = event.direction
      }
      this.deltaX = event.deltaX
      if (window.board.scrollLeft >= window.board.width) window.board.scrollLeft = window.board.width
      if (window.board.scrollLeft < 0) window.board.scrollLeft = 0
      if (this.lock === true ||
        !this.canScroll ||
        window.board.scrollLeft > window.board.width ||
        window.board.scrollLeft < 0 ||
        (this.deltaX === this.lastDelta && window.board.scrollLeft > 0)
      ) return
      if (this.lastDirection !== event.direction) {
        this.delta = this.deltaX - this.lastDelta
        window.board.scrollLeft -= this.delta
      } else {
        this.delta = this.lastDelta - this.deltaX
        window.board.scrollLeft += this.delta
      }
      this.lastDirection = event.direction
      this.lastDelta = this.deltaX
    }
  }

  initHammer () {
    // if (this.md.userAgent() === 'Safari' || this.md.phone()) {
    if (this.allowHammer()) {
      const getPos = () => {
        if (typeof window.board.dataset.pos === 'undefined') {
          return 1
        }
        return parseInt(window.board.dataset.pos)
      }

      let hammerTime = new window.Hammer(window.board, {
        inputClass: window.Hammer.TouchInput
      })
      if (window.innerHeight < 600 || window.innerWidth < 600) {
        let ColumnAmount = this.state.history.History.length + 1

        hammerTime.on('swipeleft', (ev) => {
          let newPos = (getPos() !== ColumnAmount) ? (getPos() + 1) : getPos()
          this.changePage(newPos)
        })
        hammerTime.on('swiperight', (ev) => {
          let newPos = (getPos() > 1) ? (getPos() - 1) : getPos()
          this.changePage(newPos)
        })
      } else {
        hammerTime.add(new window.Hammer.Pan({ direction: window.Hammer.DIRECTION_HORIZONTAL, threshold: 10 }))
        hammerTime.on('panstart panmove panend pancancel swipe', this.panHandler)
      }
    }
  }

  changePage (pos) {
    window.board.dataset.pos = pos
    pos = parseInt(pos) - 1
    let parent = this.refs['dragparent' + pos]

    window.board.scrollLeft = parent.offsetLeft - 5
  }

  getOrCreatePart (targetArray, partId, partName, taskSide) {
    if (targetArray === null) targetArray = []
    let i = targetArray.findIndex((item) => { return item.PartId === partId && item.PartName === partName && item.TaskSide === taskSide })
    if (i === -1) {
      let part = {
        PartId: partId,
        PartName: partName,
        TaskSide: taskSide,
        Items: []
      }
      targetArray.push(part)
      return part
    }
    return targetArray[i]
  }

  prepareForRender (entries) {
    if (entries === null) return null
    let sortedEntries = entries.sort((a, b) => {
      if (a === null && b !== null) return -1
      if (a !== null && b === null) return 1
      if (a === null && b === null) return 0
      return a.CreatedDate.localeCompare(b.CreatedDate)
    })
    return sortedEntries
  }

  getEvaluationTitle (entry) {
    let title = 'None'
    switch (entry.Type) {
      case 1:
        if (this.state.history.OrderType !== 1) {
          // title = translation('889')   // Omfang
          title = translation('14983')   // Omfang oprettet
          switch (entry.State) {
            case 1: // awaiting
              title = translation('2716')   // Prisændring afsendt
              break
            case 2: // approved/ok
              title = translation('2714')   // Prisændring godkendt
              break
            case 3: // rejected
              title = translation('2715')   // Prisændring afvist
              break
          }
        } else {
          title = translation('14716') // Manuelt
        }
        break
      case 2:
        title = translation('1396')    // Mersalg
        break
      case 3:
        title = translation('13363')   // Takseringssupport
        break
      case 4:
        title = translation('1037')    // Eftertaksering
        break
      case 5:
        title = translation('936')     // Hovedrapport
        break
      case 6:
        title = translation('937')     // Tillægsrapport
        break
      case 7:
        title = translation('15376')     // RPrapport
        break
    }
    return title
  }

  getEvaluationIcon (entry) {
    let icon = ''

    switch (entry.Type) {
      case 1:
        // icon = '/images/svgs/taksering/manually.svg'
        icon = OrderAssessmentIcons.Extent
        if (entry.State !== undefined) {
          switch (entry.State) {
            case 1: // awaiting
              icon = OrderAssessmentIcons.Invoice_Awaiting
              break
            case 2: // approved/ok
            case 3: // rejected
              icon = OrderAssessmentIcons.Invoice_Approved_Rejected
              break
          }
        }
        break
      case 2:
        icon = OrderAssessmentIcons.Addon_Price
        break
      case 3:
        icon = OrderAssessmentIcons.Estimation_Request
        if (entry.State !== undefined) {
          switch (entry.State) {
            case 1:
              icon = OrderAssessmentIcons.Estimation
              break
            case 2:
              icon = OrderAssessmentIcons.Estimation_Complete
              break
          }
        }
        break
      case 4:
        icon = OrderAssessmentIcons.After_Evaluation
        break
      case 5:
        icon = OrderAssessmentIcons.Main_Report
        break
      case 6:
        icon = OrderAssessmentIcons.Additional_Report
        break
    }
    return icon
  }

  getTaskSideName (taskSide) {
    switch (taskSide) {
      case 0:
        return ''
      case 1:
        return translation('213')  // venstre
      case 2:
        return translation('214')  // højre
      case 3:
        return translation('287')  // for
      case 4:
        return translation('288')  // bag
      case 5:
        return translation('213') + ' ' + translation('287') // venstre for
      case 6:
        return translation('214') + ' ' + translation('287') // højre for
      case 7:
        return translation('213') + ' ' + translation('288') // venstre bag
      case 8:
        return translation('214') + ' ' + translation('288') // højre bag
    }
  }

  handleClick (e) {
    e.preventDefault()

    if (this.state.swap === true) {
      this.setState({
        swap: false
      })
    } else {
      this.setState({
        swap: true
      })
    }
  }

  SortMe () {
    return (
      <div onClick={this.handleClick} className='hint--left' aria-label={this.state.swap ? translation('14996') : translation('14995')}>
        <img src={'/images/svgs/sort_chronologically.svg'} className={'sortOrder' + (this.state.swap ? ' rotate' : '')} />
      </div>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    if (this.props.auth.departmentType === 1) return null // Deny bodyshop access
    const renderHeaderGoBack = (router, t) => {
      const goBack = () => {
        this.props.router.goBack()
      }
      return (
        <div>
          <div className='alignHelper' />
          <CloseButton onClick={goBack} ariaText={translation('2060')} />
        </div>
      )
    }
    // <Header icon={'assesment-history-white.svg'} title={title} renderRight={this.SortMe.bind(this)} showBack headerButtonsGoBack={renderHeaderGoBack} />

    return (
      <div className='evaluationhistory__screen'>
        <Header router={this.props.router} renderRight={this.SortMe.bind(this)} showBack headerButtonsGoBack={renderHeaderGoBack} />
        {this.state.history !== null && this.state.history.IsOldOrder === true && (
          <div className='oldOrderHeader'>
            <span>{translation('15092')}</span>
          </div>
        )}
        {this.renderColumns()}
      </div>
    )
  }

  renderColumns () {
    if (this.state.history === null) {
      return (
        <div id='board'>&nbsp;</div>
      )
    }
    let boardClass = 'scrollbar'
    if (this.state.history !== null && this.state.history.IsOldOrder === true) {
      boardClass += ' extendedHeader '
    }
    let history = this.state.history
    let entries = this.prepareForRender(history.History)

    // Find index of addon orderprice
    let addonIndex = -1
    if (history.History !== null) {
      addonIndex = history.History.findIndex((entry) => { return entry.Type === 2 })
    }
    let evaluationSteps = null
    if (entries !== null) {
      evaluationSteps = entries.filter((entry, index) => { return index !== addonIndex }).sort((a, b) => {
        if (this.state.swap) {
          return -a.CreatedDate.localeCompare(b.CreatedDate)
        } else {
          return a.CreatedDate.localeCompare(b.CreatedDate)
        }
      })
    }
    return (
      <div id='board' className={boardClass} ref='board'>
        {this.renderInvoiceExtra()}
        {entries !== null && addonIndex > -1 && this.renderAddonEntry(entries[addonIndex])}
        {entries !== null && evaluationSteps !== null && evaluationSteps.map(this.renderEvaluationEntry)}
      </div>
    )
  }
  renderExternalSubItems (part) {
    if (part !== null && part !== undefined) {
      return (
        <div>
          {
            part.map((item, index) => {
              return (
                <div key={index + Math.floor(Math.random() * Math.floor(5000))}>
                  {translation(enumtranslate('ExternalDeviationTypes', item.DeviationType.Type))}
                </div>
              )
            })
          }
        </div>
      )
    }
  }
  renderExternalSubCustomItems (part) {
    if (part !== null && part !== undefined) {
      return (
        <div>
          {
            part.map((item, index) => {
              return (
                <div key={index + Math.floor(Math.random() * Math.floor(5000))}>
                  {item.CustomReason}
                </div>
              )
            })
          }
        </div>
      )
    }
  }

  renderExternalItems (item) {
    let history = this.state.history
    const renderDeviation = (partitem) => {
      if (partitem.parts !== null) {
        const onChange = (e) => {
          // e.persist()
          if (e.target.name === undefined || e.target.name === null) return
          partitem[e.target.name] = !partitem[e.target.name]
          // partitem.SelectedInvoice = !partitem.SelectedInvoice
          let changes = {
            OrderId: history.OrderId,
            ExternalDeviations: [partitem]
          }
          this.updateHistory(changes)
        }

        return (
          <div key={Math.floor(Math.random() * Math.floor(5000))}>
            <SelectableLine name='SelectedInvoice' checked={partitem.SelectedInvoice} extraCSS={'SelectableLineExpandend'} onChange={onChange}>
              {partitem.Parts.map((part, index) => {
                return (
                  <LabelWrapper key={index + Math.floor(Math.random() * Math.floor(5000))} labelText={part.PartDetails.Name}>
                    {this.renderExternalSubItems(part.DeviationReasons)}
                    {this.renderExternalSubCustomItems(part.CustomDeviationReasonDetails)}
                  </LabelWrapper>
                )
              })
              }
            </SelectableLine>
            <SelectableLine name='SelectedInvoiceCost' checked={partitem.SelectedInvoiceCost} onChange={onChange}>
              <Inline fillChildNum={[0]} block>
                <span>{translation('337') + ':'}</span>
                <span>{partitem.Cost} {this.props.currencyCode}</span>
              </Inline>

            </SelectableLine>
          </div>
        )
      }
    }

    if (item.ExternalDeviations !== null) {
      return (
        <div key={Math.floor(Math.random() * Math.floor(5000))}>
          {item.ExternalDeviations.map(renderDeviation)}
        </div>
      )
    }
  }

  renderInvoiceExtra () {
    let history = this.state.history

    const onOrderDataChange = (e) => {
      let name = e.target.name // getAttribute('name')
      let changes = { OrderId: history.OrderId }
      changes[name] = !this.state.history[name]
      this.updateHistory(changes)
    }

    const renderNote = (note) => {
      const onChange = (e) => {
        // e.persist()
        note.SelectedInvoice = !note.SelectedInvoice
        let changes = {
          OrderId: history.OrderId,
          Notes: [note]
        }
        this.updateHistory(changes)
      }

      let label = (
        <Grid cols={[1, 'max-content']} align='start'>
          <div>
            <UserInfo user={note.CreatedByUserInfo} />
            <div>{renderFullDate(note.CreatedDate)}</div>
          </div>
          {note.IsExternal ? <span className='hint--top' aria-label={translation('2157')}><Icon icon={ElementIcons.Customer} /></span> : ''}
        </Grid>
      )

      return (
        <SelectableLine extraCSS={'noteContent'} key={'Notes_' + note.NoteId + Math.floor(Math.random() * Math.floor(5000))} name={'Notes_' + note.NoteId} checked={note.SelectedInvoice} onChange={onChange}>
          <div className='evaluationHistory-note'>
            {label}
            <div className='text'>{translation(note.SourceDictionaryKey)}: {note.Text}</div>
          </div>
        </SelectableLine>
      )
    }
    // console.log('Evaluation history - state, props ', this.state, this.props)

    return (
      <Column ref={'dragparent' + 1} data-pos={1} noTitle>
        <Invoice invoiceOrderId={this.props.params.orderId} />
        <Section icon={EvaluationHistoryIcons.Invoice_Add} title={translation('14917')} />
        <Section extraCSS={'extraSpace'} icon={EvaluationHistoryIcons.Deviation} title={translation('383')}>
          {this.renderExternalItems(history)}
        </Section>
        {history.Notes !== null && <Section icon={EvaluationHistoryIcons.Comment} title={translation('14834')}>{history.Notes.map(renderNote)}</Section>}
        <Section title={translation('14918')} icon={EvaluationHistoryIcons.Order_Data}>
          <SelectableLine name={'OrderTypeSelected'} checked={history.OrderTypeSelected} onChange={onOrderDataChange}>
            <Inline fillChildNum={[0]} block spacing={0}>
              <div>{translation('525')}:</div>
              <div>{translation(enumtranslate('OrderTypes', history.OrderType))}</div>
            </Inline>
          </SelectableLine>
          <SelectableLine name={'PickupDateSelected'} checked={history.PickupDateSelected} onChange={onOrderDataChange}>
            <Inline fillChildNum={[0]} block spacing={0}>
              <div className='left'>{translation('156')}:</div>
              <div className='right'>{renderFullDate(history.PickupDate)}</div>
            </Inline>
          </SelectableLine>
          <SelectableLine name={'DeliveredDateSelected'} checked={history.DeliveredDateSelected} onChange={onOrderDataChange}>
            <Inline fillChildNum={[0]} block spacing={0}>
              <div className='left'>{translation('14919')}:</div>
              <div className='right'>{history.DeliveredDate ? renderFullDate(history.DeliveredDate) : translation('14999')}</div>
            </Inline>
          </SelectableLine>
          <SelectableLine name={'LtwIdCodeSelected'} checked={history.LtwIdCodeSelected} onChange={onOrderDataChange}>
            <Inline fillChildNum={[0]} block spacing={0}>
              <div className='left'>{translation('13396')}:</div>
              <div className='right'>{history.LtwIdCode}</div>
            </Inline>
          </SelectableLine>
          <SelectableLine name={'ChassisNumberSelected'} checked={history.ChassisNumberSelected} onChange={onOrderDataChange}>
            <Inline fillChildNum={[0]} block spacing={0}>
              <div className='left'>{translation('1032')}:</div>
              <div className='right'>{history.ChassisNumber}</div>
            </Inline>
          </SelectableLine>
        </Section>
      </Column>
    )
  }

  renderCreationInfoSection (entry) {
    let createdBy = (<span>&nbsp;</span>)
    if (entry.CreatedBy !== null) {
      let helpText = ''
      if (entry.CreatedByUserId === 4) {
        helpText = (
          <div>{translation(17929)}</div>
        )
      } else {
        helpText = (
          <div>
            <div>{entry.CreatedByCompany}</div>
            <div>{entry.CreatedByPhone}</div>
            <div>{entry.CreatedByMail}</div>
          </div>
        )
      }
      createdBy = (
        <div className='creation-info'>
          <UserInfo user={entry.CreatedByUserInfo} />
          <HelpText bottom text={helpText} />
        </div>
      )
    }
    return (
      <Section>
        <LabelWrapper labelText={renderFullDate(entry.CreatedDate)}>
          <div>{createdBy}</div>
          <Divider />
        </LabelWrapper>
      </Section>
    )
  }

  renderAddonEntry (entry) {
    if (entry === null) return null
    let title = this.getEvaluationTitle(entry)
    let icon = this.getEvaluationIcon(entry)

    return (
      <Column key={'entry_addon' + Math.floor(Math.random() * Math.floor(5000))} title={title} icon={icon}>
        {this.renderCreationInfoSection(entry)}
        {this.renderItemSection(entry)}
        {entry.ManualPrice !== null && (
          this.renderManualPrice(entry)
        )}
      </Column>
    )
  }

  renderFileContainer (item) {
    if (item.Files !== null && item.Files !== undefined && item.Files.length > 0) {
      let imgFiles = [...item.Files]

      const renderFile = (image, index) => {
        let url = FILE_STORAGE + image.ThumbURL
        let fullUrl = FILE_STORAGE + image.FileURL
        return (
          <div key={index + Math.floor(Math.random() * Math.floor(5000))} className='file-image fileContainer'>
            <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
          </div>
        )
      }

      return (
        <Section title={translation('1043')} icon={ElementIcons.Files}>
          <Gallery files={imgFiles} renderImage={renderFile} />
        </Section>
      )
    }
  }

  renderEvaluationEntry (entry, key, val) {
    if (entry === null) return
    let title = this.getEvaluationTitle(entry)
    let icon = this.getEvaluationIcon(entry)

    const onInvoiceClick = () => {
      entry.SelectedInvoice = !entry.SelectedInvoice
      let changes = {
        OrderId: this.state.history.OrderId,
        History: [entry]
      }
      this.updateHistory(changes)
    }

    const onWorkCardClick = () => {
      entry.SelectedWorkCard = !entry.SelectedWorkCard
      let changes = {
        OrderId: this.state.history.OrderId,
        History: [entry]
      }
      this.updateHistory(changes)
    }

    let ItemKey = 0

    if (typeof val !== 'undefined') {
      val.map((item, key) => {
        if (item.Type === 1) {
          if (item.OrderPriceId > ItemKey) {
            ItemKey = item.OrderPriceId
          }
        }
      })
    }

    const renderSelectionChecks = () => {
      let workCardChange = onWorkCardClick
      let invoiceChange = onInvoiceClick
      let fade = false

      if (this.state.history.OrderType !== 1) {
        if (entry.Type === 1) {   // && entry.OrderPriceId === ItemKey
          fade = true
          workCardChange = null
          invoiceChange = null
        }
      }

      return (
        <Section sectionCss={'columnchecks'}>
          <Inline block>
            <div className='hint--bottom-right' aria-label={translation('14997')}>
              <Check checked={entry.SelectedWorkCard} onChange={workCardChange} disabled={fade} labelText={(<span className={fade ? 'fadeOut' : ''}><Icon icon={OrderAssessmentIcons.Workcard} /></span>)} />
            </div>
            <div className='hint--bottom-right' aria-label={translation('14998')}>
              <Check checked={entry.SelectedInvoice} onChange={invoiceChange} disabled={fade} labelText={(<span className={fade ? 'fadeOut' : ''}><Icon icon={OrderAssessmentIcons.Total_Price} /></span>)} />
            </div>
          </Inline>
          <Divider />
        </Section>
      )
    }

    if (entry.Parts.length > 0 || entry.Type === 1 || entry.Type === 3 || entry.Type === 4 || entry.Type === 5 || entry.Type === 6) {
      let NewContainerKey = key + 2

      return (
        <Column key={'entry_' + key + Math.floor(Math.random() * Math.floor(5000))} title={title} ref={'dragparent' + NewContainerKey} data-pos={NewContainerKey} icon={icon}>
          {renderSelectionChecks()}
          {this.renderCreationInfoSection(entry)}
          {this.renderItemSection(entry)}
          {entry.Report !== null && (this.renderReportCalc(entry))}
          {entry.Report !== null && (this.renderReportTotals(entry))}
          {entry.ManualPrice !== null && (this.renderManualPrice(entry))}
          {this.renderAddonSection(entry)}
          {this.renderFileContainer(entry)}
        </Column>
      )
    }
  }

  renderManualPrice (entry) {
    return (
      <Section>
        <Inline block fillChildNum={[0]}>
          <span className='sumText'>{translation('13347')}:</span>
          <span className='amount'>{formatCurrency(entry.ManualPrice)}</span>
        </Inline>
        <Inline block fillChildNum={[0]}>
          <span className='sumText'>{translation('13352')}:</span>
          <span className='amount'>{formatCurrency(entry.ManualEnvironment)}</span>
        </Inline>
      </Section>
    )
  }

  renderReportTotals (entry) {
    let currency = this.props.currencyCode
    let added = ' addedprice'
    let removed = ' removedprice'
    let totalPriceClass = ''
    let totalPrice = 0
    let totalPriceWithEnv = 0
    if (entry.Report.Paint) {
      if (entry.Report.Paint.TotalPriceStatus === 1) totalPriceClass += added
      if (entry.Report.Paint.TotalPriceStatus === 2) totalPriceClass += removed

      totalPrice = entry.Report.Paint.TotalPrice
      totalPriceWithEnv = entry.Report.Paint.TotalPriceWithEnv
    }
    let summationWithStatus = entry.Report.Summation.map(x => { return {...x, ...entry.Report.SummationStatus.find(s => s.Text === x.Text)} })

    const renderSummation = (sum, index) => {
      let summationClass = ''
      if (sum.Status === 1) summationClass += added
      if (sum.Status === 2) summationClass += removed

      return (
        <div key={index} className={summationClass} >
          <Inline block fillChildNum={[0]}>
            <span className='bold'>{sum.Text}:</span>
            <span className='amount'>{formatCurrency(sum.TotalPrice)} {currency}</span>
          </Inline>
        </div>
      )
    }

    return (
      <Section>
        {summationWithStatus.filter(x => x.SumType !== 4).map(renderSummation)}
        <div className={totalPriceClass} >
          <Inline block fillChildNum={[0]}>
            <span className='bold'>{translation('18392')}:</span>
            <span className='amount'> {formatCurrency(totalPrice)} {currency}</span>
          </Inline>
        </div>
        <Divider />
        {summationWithStatus.filter(x => x.SumType === 4).map(renderSummation)}
        <div className={totalPriceClass} >
          <Inline block fillChildNum={[0]}>
            <span className='bold'>{translation('393')}:</span>
            <span className='amount'> {formatCurrency(totalPriceWithEnv)} {currency}</span>
          </Inline>
        </div>
      </Section>
    )
  }

  renderReportCalc (entry) {
    const renderMetallicMethod = (item, key) => {
      const renderAddedRefinishTypes = (item, key) => {
        return (
          <div key={Math.floor(Math.random() * Math.floor(5000))} className='added'>{item.Type}</div>
        )
      }
      let strike = false
      let addedRefinishTypes = []
      entry.RefinishTypes.map((refinishType) => {
        if (refinishType.PaintLineId !== null && refinishType.PaintLineId === item.PaintLineId) {
          strike = true
          addedRefinishTypes.push(refinishType)
        }
      })
      return (
        <div key={Math.floor(Math.random() * Math.floor(5000))} className='pg-mb-1'>
          {strike === true && (<div className='strike_through' />)}
          <span className='bold'>{item.ReportLineNumber || ''}</span> {item.ReportLineText}
          {addedRefinishTypes.map(renderAddedRefinishTypes)}
        </div>
      )
    }
    const renderStartTimes = (item, key) => {
      return (
        <Inline block fillChildNum={[0]}>
          <span className='added'>{item.Type}</span>
          <span className='added amount'>{item.Ae} {lu}</span>
        </Inline>
      )
    }
    const renderHourPrices = (item, key) => {
      return (
        <Inline block fillChildNum={[0]}>
          <span className='added'>&nbsp;</span>
          <span className='added amount'>{item.Price} {this.props.currencyCode}</span>
        </Inline>
      )
    }
    const renderMaterialsShares = (item, key) => {
      return (
        <Inline block fillChildNum={[0]}>
          <span className='added'>&nbsp;</span>
          <span className='added amount'>{item.Share} %</span>
        </Inline>
      )
    }

    let lu = translation('13345')
    let baseClass = 'reportprice'
    let addedClass = ' addedprice'
    let removedClass = ' removedprice'
    let hourClass = baseClass
    let matIndexClass = baseClass

    // - Line types
    const GENERIC_TYPE = 0
    const STARTTIME_TYPE = 4

    // - Line sub types
    const MATERIALINDEX_SUBTYPE = 1
    const REFINISH_SUBTYPE = 6

    let lines = []
    let hourPrice = 0

    if (entry.Report.Paint) {
      const { HourPriceStatus, Lines, HourPrice } = entry.Report.Paint

      if (HourPriceStatus === 1) hourClass += addedClass
      if (HourPriceStatus === 2) hourClass += removedClass

      lines = Lines
      hourPrice = HourPrice

      if (lines.some(l => l.LineSubType === MATERIALINDEX_SUBTYPE && l.Status === 1)) matIndexClass += addedClass
      if (lines.some(l => l.LineSubType === MATERIALINDEX_SUBTYPE && l.Status === 2)) matIndexClass += removedClass
    }

    // Renders start time data for a group of start times (grouped by LineSubType from Report/ReportLineSubType on OrderPriceDetail)
    const renderStartTimeGroup = (startTimeType) => {
      let reportStartTimes = lines.filter(l => l.LineType === STARTTIME_TYPE && l.LineSubType === startTimeType)
      let orderPriceStartTimes = entry.StartTimes.filter(l => l.ReportLineSubType === startTimeType)

      if (reportStartTimes.length === 0 && orderPriceStartTimes.length === 0) return null

      let startTimeClass = baseClass
      if (reportStartTimes.some(l => l.Status === 1)) {
        startTimeClass += addedClass
      } else if (reportStartTimes.some(l => l.Status === 2)) {
        startTimeClass += removedClass
      }

      return (
        <div>
          {(reportStartTimes.length > 0) && (
          <div className='report_item'>
            {orderPriceStartTimes.length > 0 && (<div className='strike_through' />)}
            <div className={startTimeClass}>
              <Inline block fillChildNum={[0]}>
                <span className='bold'>{reportStartTimes[0].LineText}</span>
                <span className='amount'>{reportStartTimes[0].WorkUnits + ' ' + lu}</span>
              </Inline>
            </div>
          </div>
          )}
          {orderPriceStartTimes.filter(l => l.PaintLineId).map(renderStartTimes)}
        </div>
      )
    }

    const renderMaterialShares = () => {
      // Get material index line if present.
      let materialIndexLines = lines.filter(l => l.LineSubType === MATERIALINDEX_SUBTYPE)
      let materialIndexLine = materialIndexLines.length > 0 ? materialIndexLines[0] : null
      const renderReportMaterialIndex = () => {
        return (
          <div className='report_item'>
            {entry.MaterialsShares.length > 0 && (<div className='strike_through' />)}
            <div className={matIndexClass}>
              <Inline block fillChildNum={[0]}>
                <span className='bold'>{materialIndexLine.LineText}</span>
                <span className='amount'>{materialIndexLine.GenericValue}</span>
              </Inline>
            </div>
          </div>
        )
      }
      return (
        <div>
          {materialIndexLine !== null && renderReportMaterialIndex()}
          {entry.MaterialsShares.map(renderMaterialsShares)}
        </div>
      )
    }

    // Gather distinct types of starttimes from both report and orderprice.
    let startTimeTypes = []
    // - report
    lines.filter(l => l.LineType === STARTTIME_TYPE).map(l => {
      if (!startTimeTypes.some(type => type === l.LineSubType)) {
        startTimeTypes.push(l.LineSubType)
      }
    })

    // - orderprice
    entry.StartTimes.map(st => {
      if (!startTimeTypes.some(type => type === st.ReportLineSubType)) {
        startTimeTypes.push(st.ReportLineSubType)
      }
    })

    return (
      <Section>
        {lines.filter(l => l.LineType === GENERIC_TYPE && l.LineSubType === REFINISH_SUBTYPE).map(renderMetallicMethod)}
        {startTimeTypes.map(renderStartTimeGroup)}
        {entry.HourPrices.length > 0 && (<div className='strike_through' />)}
        <div className={hourClass}>
          <Inline block fillChildNum={[0]}>
            <span className='bold'>{translation('419')}</span>
            <span className='amount'>{formatCurrency(hourPrice)} {this.props.currencyCode}</span>
          </Inline>
        </div>
        {entry.HourPrices.map(renderHourPrices)}
        {renderMaterialShares()}
      </Section>
    )
  }

  renderAddonSection (entry) {
    let parts = entry.Parts

    // Get start times and refinish types, not associated with forsi item.
    let startTimes = []
    let refinishTypes = []
    if (entry.StartTimes !== null) startTimes = entry.StartTimes.filter(x => x.PaintLineId === null)
    if (entry.RefinishTypes !== null) refinishTypes = entry.RefinishTypes.filter(x => x.PaintLineId === null)
    let hasOtherItems = startTimes.length > 0 || refinishTypes.length > 0

    let allDummy = true
    for (let partIndex in parts) {
      for (let itemIndex in parts[partIndex].Items) {
        let item = parts[partIndex].Items[itemIndex]
        if (!item.IsDummy) {
          allDummy = false
        }
      }
    }

    const renderOtherItems = (items, heading) => {
      if (items.length === 0) return null
      const renderOtherItem = (item, key) => {
        if (item.PaintLineId !== undefined && item.PaintLineId !== null) return
        let text = item.Type || item.Share || item.Price
        let amount = item.Ae || false
        let className = 'other_item'
        if (entry.Type === 4) className += ' added' // "other items" for after-evaluation are always "added".
        return (
          <div key={'other_' + key} className={className}>
            <span className='sumText'>{text}</span>
            {amount && <span className='amount'>{amount} {translation(885)}</span>}
          </div>
        )
      }
      return (
        <div>
          {heading && <div className='sumText bold top-spacing'>{heading}</div>}
          {items.map(renderOtherItem)}
        </div>
      )
    }

    if ((parts.length > 0 || hasOtherItems) && entry.Type === 4 && allDummy === false) {
      const renderPart = (part) => {
        let addonParts = false
        const renderItem = (item) => {
          if (item === null) return null

          const onInvoiceClick = (clickedItem) => {
            if (clickedItem !== undefined && clickedItem !== null) {
              clickedItem.SelectedInvoice = !clickedItem.SelectedInvoice
              let changes = {
                OrderId: this.state.history.OrderId,
                Modifier: clickedItem
              }
              this.updateHistory(changes)
            } else {
              item.SelectedInvoice = !item.SelectedInvoice
              let changes = {
                OrderId: this.state.history.OrderId,
                Modifier: item
              }
              this.updateHistory(changes)
            }
          }

          const onWorkCardClick = (clickedItem) => {
            if (clickedItem !== undefined && clickedItem !== null) {
              clickedItem.SelectedWorkCard = !clickedItem.SelectedWorkCard
              let changes = {
                OrderId: this.state.history.OrderId,
                Modifier: clickedItem
              }
              this.updateHistory(changes)
            } else {
              item.SelectedWorkCard = !item.SelectedWorkCard
              let changes = {
                OrderId: this.state.history.OrderId,
                Modifier: item
              }
              this.updateHistory(changes)
            }
          }

          let workcardDisabled = false
          let invoiceDisabled = false
          if (entry.Type === 4) {
            workcardDisabled = entry.SelectedWorkCard
            invoiceDisabled = entry.SelectedInvoice
          }

          let key = 'item_' + item.VisualLineNr

          if (item.IsAddon === true && item.IsDummy === false) {
            return (
              <div key={key + Math.floor(Math.random() * Math.floor(5000))}>
                <ExtentLine item={item} onInvoiceClick={onInvoiceClick} onWorkCardClick={onWorkCardClick} showPrice workcardDisabled={workcardDisabled} invoiceDisabled={invoiceDisabled} />
              </div>
            )
          }
        }

        part.Items.map((myitem, key) => {
          if (myitem.IsAddon === true) {
            addonParts = true
          }
        })

        if (addonParts === true) {
          let partName = part.PartName
          if (partName === 'None') partName = translation(227)
          return (
            <LabelWrapper labelText={this.getTaskSideName(part.TaskSide) + ' ' + partName} key={'part_' + part.PartId + '_taskside_' + part.TaskSide + '_partname_' + part.PartName.split(' ').join('') + Math.floor(Math.random() * Math.floor(5000))}>
              {part.Items.map(renderItem)}
            </LabelWrapper>
          )
        }
      }

      return (
        <Section>
          <span><h3>{translation('13536')}</h3><Divider /></span>
          {parts !== null && parts.map(renderPart)}
          {startTimes !== null && renderOtherItems(startTimes, translation(1195))}
          {refinishTypes !== null && renderOtherItems(refinishTypes, translation(161))}
        </Section>
      )
    }
  }

  renderItemSection (entry) {
    let parts = entry.Parts
    let priceEntries = entry.PriceEntries
    const renderPart = (part) => {
      let originalParts = false
      const renderItem = (item) => {
        if (item === null) return null

        const onInvoiceClick = (clickedItem) => {
          clickedItem.SelectedInvoice = !clickedItem.SelectedInvoice
          let changes = {
            OrderId: this.state.history.OrderId,
            Modifier: clickedItem
          }
          this.updateHistory(changes)
        }

        const onWorkCardClick = (clickedItem) => {
          clickedItem.SelectedWorkCard = !clickedItem.SelectedWorkCard
          let changes = {
            OrderId: this.state.history.OrderId,
            Modifier: clickedItem
          }
          this.updateHistory(changes)
        }

        let key = 'item_' + item.VisualLineNr
        let workcardDisabled = false
        let invoiceDisabled = false
        if (entry.Type === 4) {
          workcardDisabled = entry.SelectedWorkCard
          invoiceDisabled = entry.SelectedInvoice
        }
        if (item.IsAddon === false) {
          return (
            <ExtentLine item={item} entry={entry} onInvoiceClick={onInvoiceClick} onWorkCardClick={onWorkCardClick} workcardDisabled={workcardDisabled} invoiceDisabled={invoiceDisabled} key={key + Math.floor(Math.random() * Math.floor(5000))} />
          )
        }
      }

      part.Items.map((myitem, key) => {
        if (myitem.IsAddon === false) {
          originalParts = true
        }
      })
      let partCss = 'part'
      if (part.ReportLineAdded) {
        partCss += ' added'
      } else if (part.ReportLineRemoved) {
        partCss += ' removed'
      }
      if (originalParts === true) {
        let partName = part.PartName
        if (partName === 'None') partName = translation(227)
        return (
          <div key={'part_' + part.PartId + '_taskside_' + part.TaskSide + '_partname_' + part.PartName.split(' ').join('') + Math.floor(Math.random() * Math.floor(5000))} className={partCss}>
            <LabelWrapper labelText={partName}>
              {part.Items.map(renderItem)}
            </LabelWrapper>
          </div>
        )
      }
    }
    const renderOtherPriceEntries = (item, key) => {
      if (item.EntryType === null || item.EntryType < 9) return null
      return renderPriceEntry(item)
    }
    const renderPriceEntry = (item) => {
      let partCss = 'part'
      if (item.PriceStatus === 1) {
        partCss += ' added'
      } else if (item.PriceStatus === 2) {
        partCss += ' removed'
      }
      return (
        <div className={partCss}>
          <Inline block fillChildNum={[0]}>
            <span>{item.Name}</span>
            <span className=''>{formatCurrency(Number(item.Amount))} {this.props.currencyCode}</span>
          </Inline>
        </div>
      )
    }
    const renderStartPrice = () => {
      if (entry.StartPriceGross === null || (entry.Type !== 1 && entry.Type !== 2)) return null
      return (
        <Inline block fillChildNum={[0]}>
          <span>{translation(13378)}</span>
          <span>{formatCurrency(Number(entry.StartPriceGross))} {this.props.currencyCode}</span>
        </Inline>
      )
    }
    let environment = priceEntries.filter((item) => item.EntryType === 2)[0]
    let gross = priceEntries.filter((item) => item.EntryType === 0)[0]
    if (environment) {
      environment.Name = translation('13379')
    }
    if (gross) {
      gross.Name = translation('13350')
    }
    return (
      <Section>
        {renderStartPrice()}
        {parts !== null && parts.map(renderPart)}
        {priceEntries !== null && priceEntries.map(renderOtherPriceEntries)}
        {environment && renderPriceEntry(environment)}
        {gross && renderPriceEntry(gross)}
      </Section>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {
  getEvaluationHistory,
  updateEvaluationHistory,
  getOrder,
  setPageTitle,
  triggerPopup,
  triggerPopupActionBG
})(EvaluationHistory)



// WEBPACK FOOTER //
// ./src/app/pages/EvaluationHistory/index.js